export default {
    SET_LIST(state, contacts){
        state.list = contacts
    },
    SET_CURRENT_CONTACT(state, contact){
        state.current_contact = contact
    }
}